import "./DashboardTransaction.css";

const DashboardTransaction = () => {
  return (
    <div className="dashboardTransaction flex-column">
      <div className="dashboardTransaction__container">
        <h1>Transactions</h1>
        <ul>
          <li className="flex-row">
            <div className="flex-row">
              <div className="dashboardTransaction__icon rounded">
                <svg
                  viewBox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.78906 0C4.36906 0 0.789062 0.5 0.789062 4V14C0.789062 14.88 1.17906 15.67 1.78906 16.22V18C1.78906 18.55 2.23906 19 2.78906 19H3.78906C4.33906 19 4.78906 18.55 4.78906 18V17H12.7891V18C12.7891 18.55 13.2391 19 13.7891 19H14.7891C15.3391 19 15.7891 18.55 15.7891 18V16.22C16.3991 15.67 16.7891 14.88 16.7891 14V4C16.7891 0.5 13.2091 0 8.78906 0ZM14.4491 2.99H3.12906C3.67906 2.46 5.09906 2 8.78906 2C12.4791 2 13.8991 2.46 14.4491 2.99ZM14.7891 4.99V8H2.78906V4.99H14.7891ZM14.4491 14.73L14.1591 15H3.41906L3.12906 14.73C2.99906 14.62 2.78906 14.37 2.78906 14V10H14.7891V14C14.7891 14.37 14.5791 14.62 14.4491 14.73Z"
                    fill="#4318FF"
                  />
                  <path
                    d="M5.5 14C6.32843 14 7 13.3284 7 12.5C7 11.6716 6.32843 11 5.5 11C4.67157 11 4 11.6716 4 12.5C4 13.3284 4.67157 14 5.5 14Z"
                    fill="#4318FF"
                  />
                  <path
                    d="M12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14Z"
                    fill="#4318FF"
                  />
                </svg>
              </div>
              <div>
                <h3>Public Transport</h3>
                <span>22 September 2020</span>
              </div>
            </div>
            <strong>-$70.00</strong>
          </li>
          <li className="flex-row">
            <div className="flex-row">
              <div className="dashboardTransaction__icon rounded">
                <svg
                  viewBox="0 0 23 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.7891 7H16.9991L12.6191 0.440004C12.4291 0.160004 12.1091 0.0200043 11.7891 0.0200043C11.4691 0.0200043 11.1491 0.160004 10.9591 0.450004L6.57906 7H1.78906C1.23906 7 0.789062 7.45 0.789062 8C0.789062 8.09 0.799062 8.18 0.829062 8.27L3.36906 17.54C3.59906 18.38 4.36906 19 5.28906 19H18.2891C19.2091 19 19.9791 18.38 20.2191 17.54L22.7591 8.27L22.7891 8C22.7891 7.45 22.3391 7 21.7891 7ZM11.7891 2.8L14.5891 7H8.98906L11.7891 2.8ZM18.2891 17L5.29906 17.01L3.09906 9H20.4891L18.2891 17ZM11.7891 11C10.6891 11 9.78906 11.9 9.78906 13C9.78906 14.1 10.6891 15 11.7891 15C12.8891 15 13.7891 14.1 13.7891 13C13.7891 11.9 12.8891 11 11.7891 11Z"
                    fill="#01B574"
                  />
                </svg>
              </div>
              <div>
                <h3>Grocery Store</h3>
                <span>18 September 2020</span>
              </div>
            </div>
            <strong>-$1500.00</strong>
          </li>
          <li className="flex-row">
            <div className="flex-row">
              <div className="dashboardTransaction__icon rounded">
                <svg
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.78906 4H18.7891V6H2.78906V4ZM4.78906 0H16.7891V2H4.78906V0ZM18.7891 8H2.78906C1.68906 8 0.789062 8.9 0.789062 10V18C0.789062 19.1 1.68906 20 2.78906 20H18.7891C19.8891 20 20.7891 19.1 20.7891 18V10C20.7891 8.9 19.8891 8 18.7891 8ZM18.7891 18H2.78906V10H18.7891V18ZM8.78906 10.73V17.26L14.7891 14L8.78906 10.73Z"
                    fill="#FFB547"
                  />
                </svg>
              </div>
              <div>
                <h3>Public Transport</h3>
                <span>22 September 2020</span>
              </div>
            </div>
            <strong>-$154.92</strong>
          </li>
        </ul>
      </div>
      <button className="btn">
        View All
        <svg
          width="19"
          height="12"
          viewBox="0 0 19 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.789063 7L14.9591 7L11.3791 10.59L12.7891 12L18.7891 6L12.7891 -5.24537e-07L11.3791 1.41L14.9591 5L0.789063 5L0.789063 7Z"
            fill="#077aff"
          />
        </svg>
      </button>
    </div>
  );
};

export default DashboardTransaction;
